<div class="nav hidden-print">
    <div class="page">
      <ul class="menu menuleft">
        <li>
          <span class="logo">
            <img ngSrc="/InnerLogo/0" width="32" height="32" priority />
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.ANALYTICS)">
          <span [routerLink]="['/dashboard']">
            <img src="/assets/icons/navigation/dashboard_white.svg" />{{ 'Analytics' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.TRACKING)">
          <span [routerLink]="['/tracking']">
            <img src="/assets/icons/navigation/tracking_white.svg" />{{ 'Tracking' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="this.usersService.InterfaceIsPermitted(InterfacePermissions.HISTORY)">
          <span [routerLink]="['/history']">
            <img src="/assets/icons/navigation/history_white.svg" />{{ 'History' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.REPORTS)">
          <span [routerLink]="['/reports']">
            <img src="/assets/icons/navigation/reports_white.svg" />{{ 'Reports' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DRIVERS)">
          <span [routerLink]="['/drivers']">
            <img src="/assets/icons/navigation/drivers_white.svg" />{{ 'Drivers' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.SERVICE)">
          <span [routerLink]="['/service']">
            <img src="/assets/icons/navigation/services_white.svg" />{{ 'Service' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DISPATCHER)">
          <span [routerLink]="['/dispatcher']">
            <img src="/assets/icons/navigation/dispatcher.svg" />{{ 'Dispatcher' | translate }}
          </span>
        </li>
        <li [routerLinkActive]="['active']" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
          <span [routerLink]="['/datainfo']">
            <img src="/assets/icons/navigation/sim_white.svg" />{{ 'Raw data' | translate }}
          </span>
        </li>

      </ul>
        <ul class="menu menuright">
            <li>
              <span class="notifybtn onlyicon" style="display:none">
                <img src="/assets/icons/navigation/bell.svg" />
                <div>3</div>
              </span>
            </li>
            <li>
                <span class="menubtn" (click)="this.openUsersDialog()">
                    <img src="/assets/icons/navigation/user_white.svg" />
                    <div [title]="usersService.getProfileUserName()" class="label-text-elipsis">{{usersService.getProfileUserName()}}</div>
                </span>
            </li>
            <li *ngIf="languages && languages.length > 1">
                <div class="dropdown dropclick">
                    <input id="language" type="text" readonly="readonly" value="{{language.discription}}" />
                    <ul>
                        <li *ngFor="let language of languages" (click)="changeLanguage(language.code)">{{language.discription}}</li>
                    </ul>
                </div>
            </li>
            <li [routerLinkActive]="['active']" class="panelbtn" *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.EDIT)">
                <span class="menubtn panelbtn" [routerLink]="['/admin']">
                    <img src="/assets/icons/navigation/settings_white.svg" />
                    <div>{{ 'Control panel' | translate }}</div>
                </span>
            </li>
            <li (click)="logout()">
                <span class="onlyicon">
                    <img src="/assets/icons/navigation/exit_white.svg" />
                </span>
            </li>
        </ul>
    </div>
</div>
<template #navUsersDialog></template>
